import ShelfDirection from './ShelfDirection'
import GlideType from './GlideType'
export class CoolerInfo {
    RequestID: number;
    RemoveReasonID?: number;
    InstallReasonID?: number;
    Accessories: string;
    SpaceConstraints: boolean;
    Dimensions: string;
    Height: string;
    Width: string;
    Depth: string;
    Casters: boolean;
    Glides: boolean;
    Locks: boolean;
    ShelfDirectionID?: number;
    ShelfDirection?: ShelfDirection;
    GlideTypeID?: number;
    GlideType?: GlideType;
    ProjectedVolume?: number;
}

export default CoolerInfo;